import { render, staticRenderFns } from "./CRIcon.vue?vue&type=template&id=1a59b39b&scoped=true"
import script from "./CRIcon.vue?vue&type=script&lang=js"
export * from "./CRIcon.vue?vue&type=script&lang=js"
import style0 from "./CRIcon.vue?vue&type=style&index=0&id=1a59b39b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59b39b",
  null
  
)

export default component.exports